module.exports = __webpack_public_path__ + "static/img/Documentation_v1_SFig6_v2.ed583d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Documentation_v1_SFig6_v2.jpg
// module id = 523
// module chunks = 1